import { useState, useEffect, useCallback } from "react";
export const usePagedScroll = (ref, items, perPage) => {
    const [scrollPageIndex, setScrollPageIndex] = useState(0);
    const pageCount = Math.ceil(items.length / perPage);
    const scrollCallback = useCallback(({ target }) => {
        const { scrollWidth, scrollLeft } = target;
        setScrollPageIndex(() => Math.round((scrollLeft / scrollWidth) * pageCount));
    }, [pageCount]);
    const scrollToPageCallback = useCallback((pageNo) => {
        if (!ref.current)
            return;
        const { clientWidth } = ref.current;
        ref.current.scrollTo({ left: clientWidth * pageNo, behavior: "smooth" });
    }, [ref]);
    useEffect(() => {
        if (!ref.current)
            return;
        const node = ref.current;
        node.addEventListener("scroll", scrollCallback, { passive: true });
        return () => node.removeEventListener("scroll", scrollCallback);
    }, [pageCount, scrollCallback, ref]);
    return { pageCount, scrollPageIndex, scrollToPageCallback };
};
